import axios, { CancelToken } from 'axios';

import { PRICEMOOV_AUTH_KEY, clearAuthCache } from 'redesign/helpers/auth';
import localStorage from 'redesign/helpers/localStorage';

import ApiClient, { getHeaders } from './api_client';

class AuthClient extends ApiClient {
    public constructor() {
        super();
        this.paths = {
            logout: '/logout/',
            sso: '/login/sso/',
            sendPasswordResetEmail: '/password/send_email/',
            resetPassword: '/password/reset/',
            setupPassword: '/password/setup/',
            register: '/register/',
            getCatalogConfig: '/config/get_catalog_config/',
            getConfig: '/config/get_config/',
            getLoginConfig: '/config/get_login_config',
            getCarrier: '/division/',
            selectCarrier: '/division/set_selected_divisions/',
        };
    }

    public async logout() {
        const response = await axios.post(this.url('logout'), null, {
            headers: getHeaders(),
        });
        return response.data;
    }

    public sso_redirect() {
        return this.url('sso');
    }

    public async setupPassword(params: any, validationToken: string) {
        const response = await axios.post(this.url('setupPassword'), params, {
            headers: {
                ...getHeaders(false),
                Authorization: `jwt ${validationToken}`,
            },
        });
        return response.data;
    }

    public async resetPassword(params: any, validationToken: string) {
        const response = await axios.post(this.url('resetPassword'), params, {
            headers: {
                ...getHeaders(false),
                Authorization: `jwt ${validationToken}`,
            },
        });
        return response.data;
    }

    public async sendPasswordResetEmail(email: string) {
        const response = await axios.post(this.url('sendPasswordResetEmail'), { email });
        return response.data;
    }

    public register = async (params: any) => {
        const formatPayload = (payload: any) => {
            const {
                language,
                marketplaces,
                optin,
                sku_magnitude,
                gender,
                phone,
                country,
                ...restParams
            } = payload;
            return {
                language: language.code,
                ...restParams,
            };
        };
        const response = await axios.post(this.url('register'), formatPayload(params));
        return response.data;
    };

    public getConfig = async (cancelToken?: CancelToken, pricingZoneCodes?: string[]) => {
        const response = await axios
            .get(this.url('getConfig'), {
                params: { pricing_zone_codes: pricingZoneCodes?.join(',') },
                headers: getHeaders(),
                cancelToken,
            })
            .catch(error => {
                // clear auth cache if error and user is connected
                if (localStorage.get(PRICEMOOV_AUTH_KEY)) {
                    clearAuthCache();
                }
                return error;
            });

        return response.data;
    };

    public getCarriers = async (cancelToken?: CancelToken) => {
        const response = await axios.get(this.url('getCarrier'), {
            headers: getHeaders(),
            cancelToken,
        });
        return response.data;
    };

    public selectCarrier = async (code: string, cancelToken?: CancelToken) => {
        const response = await axios.patch(
            this.url('selectCarrier'),
            { division_codes: [code] },
            {
                headers: getHeaders(),
                cancelToken,
            }
        );
        return response.data;
    };
}

export default AuthClient;
